<template>
  <el-dialog :visible.sync="visible" class="growth-dialog" :title="$t('siteBuild.growth')" :width="$store.getters.isDesktop ? '600px' : '100%'" append-to-body>
    <div class="growth-dialog__body mt-5 pb-4 text-black">
      <div class="px-4">{{ $t('siteBuild.currentGrowth') }}：<span class="text-[24px] font-bold">{{ $store.state.user.vipUserInfo.growth }}</span></div>
      <el-scrollbar v-loading="loading" class="list mt-4 h-[300px] overflow-auto px-4">
        <div v-for="(item, index) in list" :key="'child' + index" class="item mb-5 flex items-center justify-between">
          <div class="left-name">
            <div>{{ $t(item.type_name) }}</div>
            <div>{{ item.create_time }}</div>
          </div>
          <div class="value">
            <i v-if="item.amount > 0" class="el-icon-plus font-bold" /> {{ item.amount }}
          </div>
        </div>
      </el-scrollbar>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import {formatZoneTime} from "~/utils";
import {VipStatusTypeNameMap} from "~/enums/data";
export default {
  name: 'VipUserInfoGrowthDialog',
  components: {
    [Dialog.name]: Dialog
  },
  data() {
    return {
      visible: false,
      loading: false,
      list: []
    }
  },
  created() {

  },
  methods: {
    init() {
      this.visible = true
      this.$nextTick(() => {
        this.queryList()
      })
    },
    async queryList() {
      const params = {
        in_or_out: 0,
        page_size: 9999
      }
      this.loading = true
      const [err, res] = await this.$utils.to(this.$api.vip.growthLog(params))
      this.loading = false
      if (!err) {
        this.list = (res.data || []).map(item => {
          const newItem = {...item}
          newItem.create_time = formatZoneTime(newItem.create_time * 1000).text
          newItem.type_name = VipStatusTypeNameMap[item.type_name]
          return newItem
        })
      }
    }
  }
}
</script>

<style lang="less">
.growth-dialog {
  .el-dialog__body {
    padding: 0;
  }
}
</style>
